import FooterList from "components/FooterList";
import HeaderList from "components/HeaderList";
import List from "components/List";

function App() {
  return (

    <div className="App">
      <HeaderList />
      <List />
      <FooterList />
    </div>

  );
}

export default App;
